import React from 'react';
import styles from './TermsInfoModal.module.css';
import BaseModal from '../../../../../../../../shared/components/BaseModal';

interface ITermsModalData {
  isOpen: boolean;
  title: string;
  content: string;
  campaignId: string;
  campaignName: string;
}

interface TermInfoModalProps {
  modalData: ITermsModalData;
  setModalData: React.Dispatch<React.SetStateAction<ITermsModalData | undefined>>;
}

const TermsInfoModal: React.FC<TermInfoModalProps> = ({ modalData, setModalData }) => {
  const closeModalIcon = '/ui/menuClose';

  return (
    <BaseModal
      styles={styles}
      closeModalIcon={closeModalIcon}
      onClose={() => setModalData((prev) => (prev ? { ...prev, isOpen: false } : prev))}
    >
      <div className={styles.modalContentWrapper}>
        <span className={styles.modalTitle}>{modalData.title}</span>
        <div className={styles.termsText} dangerouslySetInnerHTML={{ __html: modalData.content }} />
      </div>
    </BaseModal>
  );
};

export default TermsInfoModal;
